import Vue from 'vue'
import App from './App.vue'
import router from './router'
import "./elementUi"
import "@/styles/index.css"

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
